export enum MALRole {
	Follower = 'FOLLOWER',
	Reporter = 'REPORTER'
}
